import { ref } from "vue";

/**
 * État partagé du sidebar (replié / déplié), persistant.
 *
 * - `collapsed = false` : sidebar large (comportement historique, inchangé).
 * - `collapsed = true`  : rail d'icônes ; les sous-menus s'affichent dans un
 *   panneau flyout dynamique au survol (aucune régression d'accès : le gating
 *   feature-flag / rôles / permissions reste géré par MenuLink).
 *
 * L'état est défini au niveau module → partagé entre WorkspaceLayout, AppMenu
 * et MenuLink sans store dédié.
 */
const STORAGE_KEY = "jhgl.sidebar.collapsed";

function readInitial(): boolean {
	try {
		return localStorage.getItem(STORAGE_KEY) === "1";
	} catch {
		return false;
	}
}

const collapsed = ref<boolean>(readInitial());

function persist(value: boolean) {
	try {
		localStorage.setItem(STORAGE_KEY, value ? "1" : "0");
	} catch {
		/* stockage indisponible : on garde juste l'état en mémoire */
	}
}

export function useSidebar() {
	const toggle = () => {
		collapsed.value = !collapsed.value;
		persist(collapsed.value);
	};

	const setCollapsed = (value: boolean) => {
		collapsed.value = value;
		persist(value);
	};

	return { collapsed, toggle, setCollapsed };
}
